import { render, staticRenderFns } from "./headerSearch.vue?vue&type=template&id=3b09a47c&"
import script from "./headerSearch.vue?vue&type=script&lang=ts&"
export * from "./headerSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports